import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ComponentsModule } from '@core/components';
import { SharedModule } from '@core/shared.module';

import { AboutComponent } from './footer/about/about.component';
import { CopyrightComponent } from './footer/copyright/copyright.component';
import { FooterComponent } from './footer/footer.component';
import { VersionComponent } from './footer/version/version.component';
import { BreadcrumbsComponent } from './header/breadcrumbs/breadcrumbs.component';
import { HeaderComponent } from './header/header.component';
import { NavigationComponent } from './header/navigation/navigation.component';
import { SelectLanguageComponent } from './header/select-language/select-language.component';
import { UserCustomerComponent } from './header/user-customer/user-customer.component';
import { UserFacilityComponent } from './header/user-facility/user-facility.component';
import { LayoutComponent } from './layout.component';

const components = [
  AboutComponent,
  BreadcrumbsComponent,
  CopyrightComponent,
  FooterComponent,
  HeaderComponent,
  LayoutComponent,
  NavigationComponent,
  SelectLanguageComponent,
  UserCustomerComponent,
  UserFacilityComponent,
  VersionComponent,
];

@NgModule({
  declarations: components,
  imports: [ComponentsModule, CommonModule, SharedModule],
  exports: components,
})
export class LayoutModule {}
